export const TOKEN_KEY = "customer_auth_token";
export const USER_KEY = "customer_auth_user";
